import { useState, useEffect, useRef } from 'react';
import { useLingui } from '@lingui/react';
import { TUVComparisonChart } from './TUVComparisonChart';
import { useAppConfiguration, useTrackEvent } from '@wkda/funnel-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const setTrackingData = function () {
  let action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Click';
  return {
    action: 'eventTracking',
    category: 'lead-form',
    eventData: {
      category: 'TÜV tooltip',
      action,
      label: 'Open Tooltip'
    }
  };
};
export const TUVPriceInfoTooltip = () => {
  const {
    i18n
  } = useLingui();
  const track = useTrackEvent();
  const {
    hasTuvTooltip = false
  } = useAppConfiguration();
  const tooltipRef = useRef(null);
  const textInfoRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  // Add useEffect to handle outside clicks
  useEffect(() => {
    function handleOutsideClick(event) {
      // Don't close if clicking on the tooltip itself or the text info that opens it
      if (tooltipRef.current && !tooltipRef.current.contains(event.target) && textInfoRef.current && !textInfoRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    }
    if (showTooltip) {
      document.addEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [showTooltip]);
  const handleMouseEnter = () => {
    if (!showTooltip) {
      track(setTrackingData('Hover'));
    }
    setShowTooltip(true);
  };
  const handleClick = () => {
    if (!showTooltip) {
      track(setTrackingData('Click'));
    }
    setShowTooltip(!showTooltip);
  };
  const handleClose = () => {
    setShowTooltip(false);
  };
  if (!hasTuvTooltip) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "TUV-price-info",
    children: [/*#__PURE__*/_jsxs("p", {
      className: "TUV-price-info__text",
      onMouseEnter: handleMouseEnter,
      onClick: handleClick,
      ref: textInfoRef,
      children: [/*#__PURE__*/_jsx("span", {
        className: "double-booking__header",
        dangerouslySetInnerHTML: {
          __html: i18n._('carlead.tuvTooltip.info.text')
        }
      }), /*#__PURE__*/_jsx("div", {
        className: "TUV-price-info__icon",
        children: /*#__PURE__*/_jsx("span", {
          children: "i"
        })
      })]
    }), showTooltip && /*#__PURE__*/_jsxs("div", {
      className: "TUV-tooltip",
      ref: tooltipRef,
      children: [/*#__PURE__*/_jsx("button", {
        className: "TUV-tooltip__close",
        onClick: handleClose,
        children: "\xD7"
      }), /*#__PURE__*/_jsx("header", {
        className: "TUV-tooltip__header",
        dangerouslySetInnerHTML: {
          __html: i18n._('carlead.tuvTooltip.headline')
        }
      }), /*#__PURE__*/_jsx("p", {
        className: "TUV-tooltip__subheadline",
        children: i18n._('carlead.tuv.priceComparisonChart.description')
      }), /*#__PURE__*/_jsx(TUVComparisonChart, {}), /*#__PURE__*/_jsx("a", {
        className: "TUV-tooltip__link",
        href: i18n._('carlead.tuvTooltip.info.linkHref'),
        children: i18n._('carlead.tuvTooltip.info.linkText')
      })]
    })]
  });
};